var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 6.4094L13.3813 12L19 17.5906L17.5953 19L11.9766 13.4094L6.40468 19L5 17.5906L10.5719 12L5 6.4094L6.40468 5L11.9766 10.5906L17.5953 5L19 6.4094Z","fill":"black"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
